import { z } from 'zod';
import { FamilyId, AcademicYear } from '../types/branded';

export const FamilyBalanceSummarySchema = z.object({
  familyId: FamilyId,
  academicYear: AcademicYear,
  totalCharges: z.number(),
  totalCredits: z.number(),
  netBalance: z.number(),
});
export type FamilyBalanceSummary = z.infer<typeof FamilyBalanceSummarySchema>;
